import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Suspense } from 'react'

import { ProvideIrcContext } from 'components/IrcModule'
import { Loading } from 'components/Loading'

import BaseLayout from 'containers/Layout'

import { requireAuth } from 'lib/routeGuards'

import NotFound from 'pages/NotFound'

export const Route = createFileRoute('/_auth')({
  beforeLoad: requireAuth,
  component: AuthLayout,
  notFoundComponent: () => (
    <Suspense fallback={<Loading />}>
      <NotFound />
    </Suspense>
  ),
})

function AuthLayout() {
  return (
    <BaseLayout>
      <ProvideIrcContext>
        <Outlet />
      </ProvideIrcContext>
    </BaseLayout>
  )
}
